import $ from 'jquery';
import get from 'lodash.get';
import uslug from 'uslug';
import screenSize from '../services/screen_size';

/*
    Fetches data for posts from a data config object obtained from ad call, populate Featured Series module with said data
    An sample data object looks like this
    data = {
        adslot: 'nativetile_1', // name of the ad slot tile, we use it for position targetting
        adzone: '/4160/mv.fc/qa/homepage', // For ad targetting
        article_ids: [],    // 0 or more, if it's more than one, it will be comma delimited, in that case pick a random one out of them
        supertag: 'Masters Of Marketing', // Always provided
        clickthroughURL: 'some_dfp_url?redirect_url=',  // Prepend this to the actualy clickthrough URL href
        tile_type: 'Standard Editorial Collection' OR 'Custom Sponsored Collection'  OR 'Mixed Custom Sponsored Collection'// Which type of sponsorship it is
    }

    Conditions:
    1) Look at tile_type to determine how the UI should present the data
    2) If no article ID provided, a supertag will be provided, and it will select 1 article from that supertag, the default supertag value of 'default' will be sent when there's nothing qualifies to be sent
    3) clickthroughURL needs to be prepended to href, example: some_dfp_url?redirect_url=//www.foo.com
    4) Need a custom api key for access, if it's not provided, return

    Scenarios:
    Scenario 1: Custom Sponsored Takeover, 4 tiles served all with the same supertag
    Scenario 2: Custom Sponsored Mix, 4 tiles served with mixed supertags
    Scenario 3: Standard Edit Takeover, 4 tiles served with same supertag
    Scenario 4: Custom Sponsored Takeover, 4 tiles served all with the same supertag, but the click through url for each article goes to a custom url provided by adData
*/

/**
 * @param  {Object}  adData Ad object returned from ad call, contains information for which data to fetch through API and present to UI
 */
const fetchTilesFeaturedSeries = function (adData) {
    if (!adData || !adData.api_key || adData.api_key !== 'af77d18f59b563bc3f1cc998122e5e1e') {
        return;
    }

    const apiEndpoint = `/api/v3/get_post_data`;
    const adSlot = adData.ad_slot;
    const tileType = adData.tile_type;
    const supertag = uslug(adData.supertag);
    let firstArticle = get(adData, 'article_ids[0]');

    // Show the module once this contains data we need to render it
    $('.fifteen-five-layout.fifteen-five-layout.featured-series').css({
        opacity: 1
    });

    //================Construct GET params for API based on the adData passed============
    let GETParams = {};

    // If it contains an article in article array
    if (firstArticle && firstArticle !== '') {
        const articleIDSplit = firstArticle.split(',');
        const articleIDSplitLength = articleIDSplit.length;
        const randomSeed = Math.floor(Math.random() * articleIDSplitLength) + 0;
        firstArticle = articleIDSplit[randomSeed];

        GETParams = {
            nid: firstArticle
        };
    } else if (adData.supertag) {
        // If it contains a supertag
        // Call the API with supertag param
        GETParams = {
            supertag: supertag
        };

        if (adData.tile_type !== 'Mixed Custom Sponsored Collection') {
            GETParams.adSlot = adSlot;
        }
    }

    //================Make API call to /api/v3/get_post_data============
    $.ajax({
        url: apiEndpoint,
        data: GETParams
    })
    .done((data) => {
        // Apply the data to the tiles within the module
        transformTile(data, adSlot, adData);
    })
    .fail(() => {
        // If something went wrong, hide the whole module
        handleFailure();
    });

    // UI related changes, change dom to display the module in Sponsored form or in Standard form
    if (tileType === 'Standard Editorial Collection') {
        fetchSeriesMetadata(supertag, adSlot);
    } else {
        transformToCustom(tileType, supertag, adData);
    }
};

//================Figure out which tile the ad call is making to, map it here============
/**
 * @param  {String} adSlot The slot name returned from ad call to specify which tile to put the data in
 * @return {String} a classname corresponding to the tle number
 */
function figureOutTile(adSlot) {
    if (adSlot === 'nativetile_1') {
        return 'featured-series__left-top';
    } else if (adSlot === 'nativetile_2') {
        return 'featured-series__right-top';
    } else if (adSlot === 'nativetile_3') {
        return 'featured-series__right-bottom';
    } if (adSlot === 'nativetile_4') {
        return 'featured-series__left-bottom';
    }
}

//================Apply data return from server and transform the page to make it look correct============
/**
 * @param  {Object} data Data returned from the post API about this specific node id
 * @param  {Object} adSlot The slot name returned from ad call to specify which tile to put the data in
 * @param  {adData} adData Ad object returned from ad call, contains information for which data to fetch through API and present to UI
 */
function transformTile(data, adSlot, adData) {

    /*
        Example data response:
        {
            advertiser: "SteelHouse"
            posterImage:"//c.fastcompany.net/multisite_files/fastcompany/imagecache/w/575/h/323/crop/poster/2016/04/3058018-poster-26911fastcomastermattupdated.png"
            title:"Staying True To Your Strategic Focus"
            url: "//www.fastcompany.com/3058018/masters-of-marketing/staying-true-to-your-strategic-focus"
        }
    */

    const tileClass = figureOutTile(adSlot);
    const $tile = $(`.fifteen-five-layout.fifteen-five-layout.featured-series .${tileClass}`);

    let {advertiser, posterImage, title, url} = data.post;
    const {clickthroughUrl, supertag} = adData;
    const tileType = adData.tile_type;

    let presentedByText = '';
    if (advertiser && tileType === 'Mixed Custom Sponsored Collection') {
        presentedByText = `<div class="custom-featured-series__post-sponsor">Presented by ${advertiser}</div>`;
    }

    // Description box for custom module, this should only show on the left bottom tile of the module
    let fastcoWorksDescriptionBox = '';
    let titleWrapperClass = 'featured-series__vert-align-title';
    let h4TitleClass = 'featured-series__title';

    // Transformation when this is a custom module scenario
    if (tileType === 'Custom Sponsored Collection' || tileType === 'Mixed Custom Sponsored Collection') {

        $('.fifteen-five-layout.fifteen-five-layout.more-from-our-sites .featured-series__layout-column').addClass('custom-featured-series__layout-column');

        // Custom sponsorships need different fonts
        titleWrapperClass = 'custom-featured-series__vert-align-title';
        h4TitleClass = 'custom-featured-series__title';

        // Place Program description at the very last tile if it's on mobile, otherwise place it on bottom left tile
        if (screenSize.getSize() === 'small' && tileClass === 'featured-series__right-bottom') {
            fastcoWorksDescriptionBox = ` <div class="custom-content-program-description left-side">
                                                                        In partnership with FastCo.Works, Fast Company's branded content studio
                                                                    </div>`;
            // leftBottomClass = 'featured-series__left-bottom is-fastco-works';
        } else if (screenSize.getSize() !== 'small' && tileClass === 'featured-series__left-bottom') {
            fastcoWorksDescriptionBox = ` <div class="custom-content-program-description left-side">
                                                                        In partnership with FastCo.Works, Fast Company's branded content studio
                                                                    </div>`;
            // leftBottomClass = 'featured-series__left-bottom is-fastco-works';
        }

        if (screenSize.getSize() === 'small' && typeof posterImage === 'string') {
            posterImage = posterImage.replace(/w\/\d*\/h\/\d*/, 'w/425/h/319');
        }

        if (screenSize.getSize() === 'small' && tileClass === 'featured-series__right-bottom') {
            // Todo handle mobile here
        } else if (screenSize.getSize() !== 'small' && tileClass === 'featured-series__right-top') {
            // rightTopClass = 'right-top--custom-topic';
        }

        // For mobile, the title needs to transform properly
        if (screenSize.getSize() === 'small' && tileClass === 'featured-series__left-top') {
            titleWrapperClass = 'custom-featured-series__post-title-container';
            h4TitleClass = 'custom-featured-series__post-title';
        }
    }

    if (screenSize.getSize() === 'small' && tileClass === 'featured-series__left-top') {
        titleWrapperClass = 'featured-series__post-title-container';
        h4TitleClass = 'featured-series__post-title';
    }

    if (screenSize.getSize() === 'small' && tileType === 'Standard Editorial Collection') {
        $('.ad-wrapper-small').addClass('ad-wrapper-small--featured-series');
    }

    if (adData.url) {
        url = adData.url;
    }

    // Append tracking to url
    url = `${url}?icid=np201${uslug(supertag)}`;

    const tileContent = `<a href="${clickthroughUrl}${url}">
                            <article class="featured-series__story">
                                <figure class="featured-series__poster-wrapper aspect-ratio--mobile-four-three">
                                    <img class="card-bg" src="${posterImage}" />
                                </figure>
                                <div class="${titleWrapperClass}">
                                    <h4 class="${h4TitleClass}"><span>${title}</span></h4>
                                    ${presentedByText}
                                </div>
                            </article>
                        </a>
                        ${fastcoWorksDescriptionBox}`;

    // transformToCustom();
    $tile.append(tileContent);
}

//================Apply classes or dom changes to make the module look like a custom module============
/**
 * Apply classes or dom changes to make the module look like a custom module
 * @param  {String} tileTye The type of tile we are getting from ad response to signify what type of scenario this is
 * @param  {String} supertag Name of the supertag we need to fetch from the api
 * @params {Object} adData adData Ad object returned from ad call, contains information for which data to fetch through API and present to UI
 */
function transformToCustom(tileType, supertag, adData) {
    $('.fifteen-five-layout.fifteen-five-layout.featured-series').addClass('custom-featured-series');
    $('.featured-series__module-title').addClass('custom-featured-series__module-title');
    $('.featured-series__body').addClass('custom-featured-series__body');
    $('.featured-series__layout-column').addClass('custom-featured-series__layout-column');
    $('.featured-series__layout-column--left').addClass('custom-featured-series__layout-column--left');
    $('.featured-series__layout-column--right').addClass('custom-featured-series__layout-column--right');
    $('.featured-series__layout-column').addClass('custom-featured-series__layout-column');
    $('.featured-series__left-top').addClass('custom-featured-series__left-top');
    $('.featured-series__left-bottom').addClass('custom-featured-series__left-bottom');
    $('.featured-series__right-top').addClass('custom-featured-series__right-top');
    $('.featured-series__right-bottom').addClass('custom-featured-series__right-bottom');
    $('.featured-series__story').addClass('custom-featured-series__story');
    $('.featured-series__poster-wrapper').addClass('custom-featured-series__poster-wrapper');
    $('.featured-series__vert-align-title').addClass('custom-featured-series__vert-align-title');
    $('.featured-series__title').addClass('custom-featured-series__title');
    // $('.custom-collection-container>.layout-row-1:first').addClass('semi-circle');

    // Get from series data from server if all 4 stories are custom
    fetchSeriesMetadata(supertag, null, 'isCustom', tileType, adData);
}

//================Get info about a series and change module header to reflect that============
/**
 * @param  {String} supertag Name of the supertag to pass to the get_series_data api
 * @param  {String} adSlot The slot name returned from ad call to specify which tile to put the data in
 * @param  {String} OPTIONAL isCustom A flag to tell if we should render this function call as custom mode
 * @param  {String} OPTIONAL tileType The type of tile we are getting from ad response to signify what type of scenario this is
 *  * @params {Object} OPTIONAL adData adData Ad object returned from ad call, contains information for which data to fetch through API and present to UI
 */
function fetchSeriesMetadata(supertag, adSlot, isCustom, tileType, adData) {
    const seriesAPIEndpoint = '/api/v3/get_series_data';
    let $moduleTitle = $('.featured-series__module-title a');
    let $moduleDescription = $('.homepage-module-desc');

    $.ajax({
        url: seriesAPIEndpoint,
        data: {
            supertag,
            adSlot
        }
    })
    .done((data) => {
        if (data && data.series) {
            // Set featured series module header to reflect the supertag
            if (isCustom) {
                // It's a custom series

                // If adData.url is present, then use that as the URL of the article, and remove link from
                if (adData.url) {
                    data.series.url = null;
                }

                $moduleTitle.attr('href', data.series.url).text(data.series.title);
                // If it's mixed custom, then it should say "Created For And Commissioned By FastCoWorks", otherwise it should say "Presented by ADVERTISER_NAME"
                if (tileType && tileType === 'Mixed Custom Sponsored Collection') {
                    $('.featured-series__module-title').html('From FastCo.Works');
                    $moduleDescription.html(`<p>Stories from our sponsors</p>`);
                } else {
                    // Populate the description if it's not mix and has a description
                    $moduleDescription.html(`<p>${data.series.description}</p>`);
                }
            } else {
                // None custom, render series title and description if available
                $moduleTitle.attr('href', data.series.url).text(data.series.title);
                if (data.series.description) {
                    $moduleDescription.html(`<p>${data.series.description}</p>`);
                }
            }
        }
    })
    .fail(() => {
        // If something went wrong, hide the whole module
        handleFailure();
    });
}

//================When something go wrong, hide this module============
/**
 * When something go wrong, hide this module
 */
function handleFailure() {
    $('.fifteen-five-layout.fifteen-five-layout.featured-series').css({
        opacity: 0
    });
}

export default fetchTilesFeaturedSeries;

// Expose this function as a public function for Adops to call
window.FCAdops = window.FCAdops || {};
window.FCAdops.fetchTiles = fetchTilesFeaturedSeries;
